// This file contains the routes that are shared between the Client and Coach roles
import { defineAsyncComponent, defineComponent, h } from "vue";
import { useAuthStore } from "@/stores";

// vue-router resolves a lazy `component` function once and caches it on the
// route record, so a role check inside that function sticks with whichever
// role was signed in first (e.g. a trainer logging in after a client got the
// client page). This wrapper re-reads the role reactively on every render.
function roleSwitchedPage(loadCoachPage, loadClientPage) {
  const CoachPage = defineAsyncComponent(loadCoachPage);
  const ClientPage = defineAsyncComponent(loadClientPage);
  return defineComponent({
    setup() {
      const authStore = useAuthStore();
      return () => h(authStore.isTrainer ? CoachPage : ClientPage);
    },
  });
}

export default [
  {
    path: "/",
    name: "Dashboard",
    component: roleSwitchedPage(
      () => import("@/pages/Coaches/CoachDashboardPage.vue"),
      () => import("@/pages/Clients/ClientDashboardPage.vue")
    ),
  },

  {
    path: "/check_ins",
    name: "CheckIns",
    component: roleSwitchedPage(
      () => import("@/pages/CheckIns/CoachIndexPage.vue"),
      () => import("@/pages/CheckIns/ClientIndexPage.vue")
    ),
    meta: {
      title: "Check-Ins",
    },
  },
  {
    path: "/meal_plans",
    name: "MealPlans",
    component: () => import("@/pages/MealPlans.vue"),
  },
  {
    path: "/resources",
    name: "Resources",
    component: () => import("@/pages/ResourcePage.vue"),
    meta: {
      title: "Resources",
    },
  },
  {
    path: "/my_profile",
    name: "MyProfile",
    component: () => import("@/pages/Shared/MyProfile.vue"),
    meta: {
      title: "My Profile",
    },
  },
];
